"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkUtilsService = void 0;
const linkUtils_1 = require("./linkUtils");
const LinkUtilsService = (config = {}) => (0, linkUtils_1.createExternalLinkUtils)(config);
exports.LinkUtilsService = LinkUtilsService;
//# sourceMappingURL=linkUtilsService.js.map